export enum GateUnitPosition {
  Unknown = 0,
  Closing,
  Closed,
  OpeningEntry,
  OpenEntry,
  OpeningExit,
  OpenExit,
}
